import { render } from "./index.vue?vue&type=template&id=778ca77e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=778ca77e&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=778ca77e&lang=less"

import exportComponent from "/root/workspace/service-web_xMds/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778ca77e"]])

export default __exports__